import { TextTooltip, Tooltip, type TooltipProps } from '@carboncopyco/ui';
import { getMaxZIndex } from '@carboncopyco/utils';
import { cloneElement, useRef } from 'react';

export interface RuleTooltipProps extends Pick<TooltipProps, 'appendTo'> {
  //** The children must an accessiable ref */
  children: any;
  title: string;
  zIndex?: number;
}

function preserveRef(ref, node) {
  if (ref) {
    if (typeof ref === 'function') {
      ref(node);
    }
    if ('current' in ref) {
      ref.current = node;
    }
  }
}

export const RuleTooltip = ({
  title,
  children,
  appendTo,
  zIndex,
}: RuleTooltipProps) => {
  const currentRef = useRef(null);
  return (
    <>
      {children
        ? cloneElement(children, {
            // Inspired by TippyJS, in order to avoid wrapping the children with div which could break the layout
            // https://github.com/atomiks/tippyjs-react/blob/2699f0450c28a92cd5bbd402573ce9ed64252899/src/Tippy.js#L225
            ref(node) {
              currentRef.current = node;
              preserveRef(children.ref, node);
            },
          })
        : null}
      <Tooltip
        zIndex={zIndex ?? getMaxZIndex() + 1}
        offset={[0, 2]}
        delay={[700, 0]}
        placement="bottom"
        anchorRef={currentRef}
        trigger="mouseenter"
        noArrow
        appendTo={appendTo ?? 'parent'}
        background="dark"
        shadow="lg"
      >
        <div className="px-1.5 pb-1 pt-0 leading-none break-words max-w-75 whitespace-normal">
          <TextTooltip
            label={title}
            color="text-ds-natural-50"
          />
        </div>
      </Tooltip>
    </>
  );
};
